import React, { FC, ReactElement } from "react"

const Loading: FC = (): ReactElement => {

    return <>
        <div className="position-absolute top-0 start-0 w-100 h-100">
            <div className="text-center position-absolute top-50 start-50 w-100 translate-middle">
                <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div>
                <div className="text-muted">
                    読み込んでいます…
                </div>
            </div>
        </div>
    </>
}

export default Loading